<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("player.menu.layout") }} </template>
        <template #sidebarMain>
            <PageSettings />
            <HeaderSettings
                @editLink="$emit('editLink', $event)"
                @addLink="$emit('addLink', $event)"
            />
            <FooterSettings />
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import PageSettings from "./PageSettings.vue";
import HeaderSettings from "./HeaderSettings.vue";
import FooterSettings from "./FooterSettings.vue";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    emits: ["editLink", "addLink"],
    components: {
        PageSidebar,
        FooterSettings,
        PageSettings,
        HeaderSettings,
        cSaveButton,
    },
    computed: {
        ...mapState("player", ["player", "hasChanges"]),
    },
    methods: {
        ...mapActions("player/projects", ["saveSnapshot"]),
    },
};
</script>
